import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Alert } from "components/bootstrap";
const ESClusterError = styled(Alert)`
  margin-top: 10px;
  margin-bottom: 5px;
`;
const IndexerClusterHealthError = ({
  error,
  name = void 0
}) => {
  const { t } = useTranslation("indexsets");
  return /* @__PURE__ */ React.createElement(ESClusterError, { bsStyle: "danger" }, t("indexers.cluster_health.error", {
    distribution: (name == null ? void 0 : name.distribution) || "Elasticsearch",
    message: error.message
  }));
};
export default IndexerClusterHealthError;
